import React from 'react';
import PropTypes from 'prop-types';

import { Cover, FAQs, Layout, Link, SEO, Banner, SectionPricing, Column, SectionReviewModals } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from "utils/media";

// Content
import contentSEO from "cms/content/pricing-seo.yml";
import contentCover from "cms/content/pricing-cover.yml";
import contentBanner from "cms/content/pricing-banner.yml";
import contentPricingOne from "cms/content/pricing-step-one.yml";
import contentPricingTwo from "cms/content/pricing-step-two.yml";
import contentUpgrades from "cms/content/pricing-upgrades.yml";
import contentSecReviewModals from "cms/content/pricing-section-review-modals.yml"
import contentFaqs from "cms/content/pricing-faqs.yml"
import contentFaqsEn from "cms/content/pricing-faqs-en.yml"

const PricingPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale} className='pricing-wrapper'>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Link to={routes.apart.path} {...routes.apart} className='cta-sidetab'>What sets us apart?</Link>

    <Cover
      title={contentCover.title}
      image={{ url: media(contentCover.image), alt: 'Smile more. Pay less' }}
      button={{ label: cta.getStarted, ...routes.getStarted }}
      overlap={contentCover.overlap}
      trustpilot={contentCover.trustpilot}
      className='cover-pricing'
    />

    <Banner content={contentBanner} />

    <SectionPricing
      content={contentPricingOne}
      locale={locale}
      step="One"
    />

    <SectionPricing
      content={contentPricingTwo}
      locale={locale}
      step="Two"
    />

    <h2 className='t-center mb-50'>{ contentUpgrades.title }</h2>

    <div className='section-pricing-columns fvw'>
      <Column
        content={{
          title: contentUpgrades.col1Title,
          copy: contentUpgrades.col1Copy,
          icon: contentUpgrades.col1Icon,
          image: contentUpgrades.col1Image,
          priceUk: contentUpgrades.col1PriceUk,
          priceSe: contentUpgrades.col1PriceSe,
          priceEn: contentUpgrades.col1PriceEn,
        }}
        locale={locale}
        link={routes.teethWhitening}
      />
      <Column
        className='reverse'
        content={{
          title: contentUpgrades.col2Title,
          copy: contentUpgrades.col2Copy,
          icon: contentUpgrades.col2Icon,
          image: contentUpgrades.col2Image,
          priceUk: contentUpgrades.col2PriceUk,
          priceSe: contentUpgrades.col2PriceSe,
          priceEn: contentUpgrades.col2PriceEn,
        }}
        locale={locale}
        link={routes.maintainerPlan}
      />
    </div>

    <hr className='fvw' />

    {contentFaqs.enabled && locale === 'uk' ? <FAQs title='Pricing FAQs' faqsData={contentFaqs['faqs']} className='mb-50 mt-90' /> : ''}
    {contentFaqs.enabled && ( locale === 'en' || locale === 'se') ? <FAQs title='Pricing FAQs' faqsData={contentFaqsEn['faqs']} className='mb-50 mt-90' /> : ''}

    <SectionReviewModals content={contentSecReviewModals} />


  </Layout>
);

PricingPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default PricingPage;
